/**
 * Base URL for the Express API when the front is hosted separately
 * (e.g. Cloudflare Pages). Set REACT_APP_API_URL at build time, no trailing slash.
 * Leave unset in local dev with embedded API (same origin).
 */
export function getApiOrigin() {
  return String(process.env.REACT_APP_API_URL || "")
    .trim()
    .replace(/\/$/, "");
}

/**
 * @param {string} path - Must start with / (e.g. /api/waitlist or /api/x?y=1)
 */
export function apiUrl(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  const origin = getApiOrigin();
  if (!origin) return p;
  return `${origin}${p}`;
}
